import { PropTypes } from "base/react-libs";
import { useIdentity } from "base/identity-resolver";
import { JourneysContext } from "apps/journeys/context/journeys-context";
import { moveConstituentToJourney } from "apps/journeys/utils/api-requests/modal-actions";
import { useState, useEffect, useContext } from "react";
import { Modal, ModalHeaderWithActions, Radio, ModalBody, ListboxSelect } from "@evertrue/et-components";
import FormField from "components/forms/form-field";
import ContactList from "apps/contact/components/ContactList";
import SelectedContactsSource from "apps/contact/sources/selected-contacts-source";
import { useTasksNotificationContext } from "apps/tasks/hooks/tasks-notification-context.js";

const BulkMoveToJourneyModal = ({ isOpen, closeModal, selected, assignedContacts, handleRemove }) => {
  const { journeys, selectedJourney, refetchJourneys } = useContext(JourneysContext);
  const { getAndSetGlobalTasksDueCount } = useTasksNotificationContext();
  const { user, org } = useIdentity();
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState({});
  const [selectedContacts, setSelectedContacts] = useState(selected);
  const [onOther, setOnOther] = useState(false);

  useEffect(() => {
    setOptions(
      journeys
        .filter((j) => j.name !== selectedJourney.name)
        .map((j) => {
          return { label: j.name, value: j.journey_type, description: j.objective_description, id: j.id };
        })
    );
  }, [journeys, selectedJourney]);

  const handleSubmit = async () => {
    const promises = selectedContacts.map(
      async (contact) =>
        await moveConstituentToJourney(
          selectedJourney.id,
          contact.id,
          user.id,
          org.id,
          selectedOption.id,
          selectedOption.label
        )
    );

    await Promise.all(promises);
    closeModal();
    getAndSetGlobalTasksDueCount();
    handleRemove(selectedContacts);
    SelectedContactsSource.clearAllSelectedState();
    handleRemove(selectedContacts);
    await refetchJourneys();
    closeModal();
  };

  const handleRadioClick = (option) => {
    if (option.value === "OTHER") setOnOther(true);
    else setOnOther(false);

    setSelectedOption(option);
  };

  return (
    <Modal isOpen={isOpen} closeModal={closeModal}>
      <ModalHeaderWithActions
        title={"Move to Cadence"}
        closeModal={closeModal}
        onSubmit={handleSubmit}
        disableSubmit={!selectedOption.value || !selectedContacts.length}
      />
      <ModalBody scrollable={false}>
        <FormField label="Selected Constituents" boldLabel={true} inlineLabel={false}>
          <ContactList
            selected={selectedContacts}
            assigned={assignedContacts}
            onSelect={(selected) => {
              const selectedIds = selected.map(({ id }) => id);
              SelectedContactsSource.actions.selectContacts(selectedIds);
              setSelectedContacts(selected);
            }}
            handleUnselect={(contacts) => SelectedContactsSource.actions.unselectContacts([contacts])}
          />
        </FormField>
        <FormField label="Select a Cadence" boldLabel={true} inlineLabel={false}>
          {options
            .filter((j) => j.value.includes("INTRODUCTION"))
            .map((option) => (
              <Radio
                className="journey-modal--radio"
                key={`radio-${option.label}`}
                label={option.label}
                checked={selectedOption.value === option.value}
                onChange={() => handleRadioClick(option)}
                value={option.value}
              >
                <div>
                  <div>{option.label}</div>
                  <div>{option.description}</div>
                </div>
              </Radio>
            ))}
          <Radio
            className="journey-modal--radio"
            label={"Other"}
            checked={onOther}
            onChange={() => handleRadioClick({ value: "OTHER" })}
            value={"OTHER"}
          >
            <div>
              <div>Other Cadence</div>
            </div>
          </Radio>
          {
            <ListboxSelect
              emptyValue="Select Cadence"
              showLabelIfMultipleSelected={true}
              size="medium"
              options={options.filter((j) => !j.value.includes("INTRODUCTION"))}
              onChange={(val) => setSelectedOption(val)}
              value={selectedOption}
              label="Cadences"
              disabled={!onOther}
            />
          }
          {onOther && selectedOption.description && (
            <div className="journey-modal--alert">{selectedOption.description}</div>
          )}
        </FormField>
      </ModalBody>
    </Modal>
  );
};
BulkMoveToJourneyModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  selected: PropTypes.array,
  handleRemove: PropTypes.func,
  assignedContacts: PropTypes.array,
};
export default BulkMoveToJourneyModal;
